import { Component, OnInit, OnChanges, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SelectedServiceDialogComponent } from '../../shared/dialog/selectedServiceDialog.component';
import { LoginService } from "../../shared/services/login.service";
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';
import { BackgroundCheckService } from '../../get-my-background-check/background-shared/services/backgroundCheck.service';
import { CountryCheck } from '../../shared/models/countryCheck.model';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { EmployementVerificationModel } from '../../shared/models/employementVerificationModel';
import { DatePipe } from '@angular/common';
import { EducationVerificationModel } from '../../shared/models/educationVerificationModel';
import { MatStepper } from '@angular/material';
import { ProfessionVerificationModel } from '../../shared/models/professionVerificationModel.model';
import { MatSnackBar } from '@angular/material';
import { CommonService } from '../../shared/services/commom.service';
import { EmployementThirdVerificationModel } from '../../shared/models/employementThirdVerificationModel';
import { EmployementSecondVerificationModel } from '../../shared/models/employementSecondVerificationModel'
import * as $ from 'jquery';
import { EmployementObjectModel } from '../../shared/models/employementobjectModel'



@Component({
    selector: 'Employ-Edu-Prof-Check',
    templateUrl: './emplEduProfCheck.component.html',
})

export class EmplyEduProfCheckComponent implements OnInit, OnDestroy {
    EmployementVerificationModel: EmployementVerificationModel = new EmployementVerificationModel();
    EmployementSecondVerificationModel: EmployementSecondVerificationModel = new EmployementSecondVerificationModel();
    EmployementThirdVerificationModel: EmployementThirdVerificationModel = new EmployementThirdVerificationModel();
    EducationVerificationModel: EducationVerificationModel = new EducationVerificationModel();
    ProfessionVerificationModel: ProfessionVerificationModel = new ProfessionVerificationModel();
    EmployementObjectModel: EmployementObjectModel = new EmployementObjectModel()
    public GetState = [];
    public IsEducationVerification = false;
    public IsEditEmployementThirdDetails = false
    public IsEmployerVerification = false;
    public IsProfessionalVerfication = false;
    public Step: number;
    public IsErrorMsg = false;
    public ErrorMsg = '';
    public CountForEmployer = 0;
    public CountForEducation = 0;
    public CountForProfessional = 0;
    public EmployerServiceId = 0;
    public EducationServiceId = 0;
    public ProfessionalServiceId = 0;
    public IsProgressBar = false;


    mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    @ViewChild('stepper') stepper: MatStepper;
    public IsEditEmployementDetails = false;
    public IsEditEducationDetails = false;
    public IsEditProfessionalDetails = false;
    public InwhatCaseEnterProfessionDetails = '';
    public EmployerPackageServiceId;
    public EducationPackageServiceId;
    public ProfessionalPackageServiceId;
    public TypeOfVerification = '';
    public RemoveDetailsInWhatCase = '';
    public CounterOne = 0;
    public CounterTwo = 0;
    public IsAdditionInfo = false
    @Output() OrderTabEnabledAfterAdditionalInfo = new EventEmitter<any>();
    public FormReset;
    @ViewChild('EmployerForm') mytemplateForm: NgForm
    public IsSecondEmplyPending = false;
    public IsThirdEmployyPending = false;
    public IsEditEmployementSecondDetails = false;


    constructor(private _BackgroundCheckService: BackgroundCheckService, private _BackgroundDashboardService: BackgroundDashboardService,
        private _Router: Router, private _formBuilder: FormBuilder, private _DatePipe: DatePipe, private _snackBar: MatSnackBar,
        private _CommonService: CommonService) {
        if (localStorage.getItem("IsAdditionalInfo") !== "Yes") {
            const Services = JSON.parse(localStorage.getItem('OrderSummaryDetails'))[0].Services;
            this.CountOfServices(Services);
            this.CheckPackageService(Services);
        }

    }
    firstFormGroup: FormGroup;

    isOptional = false;

    ngOnInit() {
        if (localStorage.getItem("IsAdditionalInfo") == "Yes") {
            this.IsAdditionInfo = true
            this.SetAdditionInfoPageAccordingToPackageId()
        } else {
            if (this.IsEmployerVerification === true) {
                this.Step = 0;
            } else if (this.IsEducationVerification === true) {
                this.Step = 1;
            } else if (this.IsProfessionalVerfication === true) {
                this.Step = 2;

            }
        }
        this._BackgroundCheckService.GetState().subscribe(res => this.GetStateSuccess(res), res => this.GetStateError(res));
    }

    CountOfServices(Services) {
        this.CountForEmployer = Services.filter(x => x.ServiceMasterId === 5 && x.IsCompletedDetails === true).length + 1;
        this.CountForEducation = Services.filter(x => x.ServiceMasterId === 6 && x.IsCompletedDetails === true).length + 1;
        this.CountForProfessional = Services.filter(x => x.ServiceMasterId === 36 && x.IsCompletedDetails === true).length + 1;
    }

    GetStateSuccess(res) {
        this.GetState = res.json();
    }

    GetStateError(res) { }

    SaveTheEmployerDetails(form) {
        if (atob(localStorage.getItem("PackageId")) === "6" && localStorage.getItem("IsAdditionalInfo") === "Yes") {
            this.Step = 3;
        } else {
            if (this.IsEducationVerification) {
                this.Step = 1;
            } else if (this.IsProfessionalVerfication) {
                this.Step = 2;
            } else {
                this.stepper.selectedIndex = 1;
            }
        }
        this.EmployementVerificationModel.Address1 = this.EmployementVerificationModel.StreetNumber + " " +
            this.EmployementVerificationModel.StreetAddress
    }

    SaveEmployerThirdForm() {
        this.Step = 1;
        this.EmployementThirdVerificationModel.Address1 = this.EmployementThirdVerificationModel.StreetNumber + " " +
            this.EmployementThirdVerificationModel.StreetAddress

    }

    EmployementSecondVerification() {
        this.Step = 4;
        this.EmployementSecondVerificationModel.Address1 = this.EmployementSecondVerificationModel.StreetNumber + " " +
            this.EmployementSecondVerificationModel.StreetAddress
    }

    ConvertInDateFormat(StartDate, EndDate, IsCurrentHere) {
        let JoiningDate;
        JoiningDate = IsCurrentHere === true ?
            this._DatePipe.transform(StartDate, 'MM/dd/yyyy') + '-' + this._DatePipe.transform(new Date(), 'MM/dd/yyyy') :
            this._DatePipe.transform(StartDate, 'MM/dd/yyyy') + '-' + this._DatePipe.transform(EndDate, 'MM/dd/yyyy');

        return JoiningDate;
    }



    CheckPackageService(Packages) {
        for (let index = 0; index < Packages.length; index++) {
            const element = Packages[index];
            if (element.IsCompletedDetails === false && element.WorkPastId === '') {
                if (element.ServiceMasterId === 5) {
                    this.EmployerPackageServiceId = element.PersonalPackageServiceId;
                    this.IsEmployerVerification = true;
                } if (element.ServiceMasterId === 6) {
                    this.IsEducationVerification = true;
                    this.EducationPackageServiceId = element.PersonalPackageServiceId;
                } if (element.ServiceMasterId === 36) {
                    this.ProfessionalPackageServiceId = element.PersonalPackageServiceId;
                    this.IsProfessionalVerfication = true;
                }
            }
        }
    }

    setStep(index: number) {
        this.Step = index;
    }

    nextStep() {
        this.Step++;
    }

    prevStep() {
        this.Step--;
    }

    SaveTheEducationDetails() {
        if (this.IsProfessionalVerfication) {
            this.Step = 2;
        } else {
            this.stepper.selectedIndex = 1;
        }
    }

    EditEmployerDetails() {
        this.IsEditEmployementDetails = !this.IsEditEmployementDetails;
    }

    EditEmployerSecondDetails() {
        this.IsEditEmployementSecondDetails = !this.IsEditEmployementSecondDetails;
    }


    EditEmployerThirdDetails() {
        this.IsEditEmployementThirdDetails = !this.IsEditEmployementThirdDetails;
    }

    EditEducationDetails() {
        this.IsEditEducationDetails = !this.IsEditEducationDetails;
    }

    EditProfessionalDetails() {
        this.IsEditProfessionalDetails = true;
    }

    SaveTheProfessionalDetails(Case) {
        if (Case === 'Save') {
            this.stepper.selectedIndex = 1;
        } if (Case === 'Edit') {
            this.IsEditProfessionalDetails = false;
        }

    }

    InsertRecordOfEmplEduandPro(SaveRecordInCase) {
        this.CounterOne = 0;
        this.EmployementVerificationModel.EntryInWhichCase = '';
        this.EducationVerificationModel.EntryInWhichCase = '';
        this.ProfessionVerificationModel.EntryInWhichCase = '';
        if (this.IsEmployerVerification) {
            this.EmployementVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EmployementVerificationModel.StartDate,
                this.EmployementVerificationModel.EndDate, this.EmployementVerificationModel.CurrentlytWorkHere);
            this.EmployementVerificationModel.OrderId = atob(localStorage.getItem('OrderId'));
            this.EmployementVerificationModel.ServiceMasterId = 5;
            this.EmployementVerificationModel.EntryInWhichCase = SaveRecordInCase;

            this.CounterOne++;
            this._BackgroundDashboardService.IsEmployementRecordAlreadyExist(this.EmployementVerificationModel).
                subscribe(res => this.IsEmployementRecordAlreadyExistSuccess(res), res => this.IsEmployementRecordAlreadyExistError(res));
        } if (this.IsEducationVerification) {
            this.EducationVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EducationVerificationModel.StartDate,
                this.EducationVerificationModel.EndDate, this.EducationVerificationModel.CurrentlyEnrolled);
            this.EducationVerificationModel.OrderId = atob(localStorage.getItem('OrderId'));
            this.EducationVerificationModel.EntryInWhichCase = SaveRecordInCase;
            this.CounterOne++;
            this._BackgroundDashboardService.IsEducationRecordAlreadyExist(this.EducationVerificationModel).
                subscribe(res => this.IsEducationRecordAlreadyExistSuccess(res), res => this.IsEducationRecordAlreadyExistError(res));
        } if (this.IsProfessionalVerfication) {

            this.ProfessionVerificationModel.OrderId = atob(localStorage.getItem('OrderId'));
            this.ProfessionVerificationModel.EntryInWhichCase = SaveRecordInCase;
            this.CounterOne++;
            this._BackgroundDashboardService.IsProfessionalLicenseAlreadyExist(this.ProfessionVerificationModel)
                .subscribe(res => this.IsProfessionalLicenseAlreadyExistSuccess(res),
                    res => this.IsProfessionalLicenseAlreadyExistError(res));
        }
    }

    IsCorrectDetails() {
        this.IsProgressBar = true;
        this.InsertRecordOfEmplEduandPro('SaveInTable');
    }

    IsServiceCompletedTheInformationOrPending(PackageServiceId, IsDataCompleted, WorkPastId) {
        this.TypeOfVerification = '';
        this._BackgroundDashboardService.IsServiceCompletedTheInformationOrPending(PackageServiceId, atob(localStorage.getItem('OrderId')),
            IsDataCompleted, WorkPastId).subscribe(res => this.IsServiceCompletedTheInformationOrPendingSuccess(res),
                res => this.IsServiceCompletedTheInformationOrPendingError(res));
    }

    IsServiceCompletedTheInformationOrPendingSuccess(res) {
        this.CounterTwo++;
        if (res !== 0) {
            if (this.CounterOne === this.CounterTwo) {
                this._CommonService.IsNewServicesAddInPackage = false;
                this.IsProgressBar = false;
                const snackBarRef = this._snackBar.open('Your record saved Sucessfully',
                    'OK', {
                        panelClass: ['hideMe'], // added hideMe class in the style.scss for fade in and out
                        verticalPosition: 'bottom'
                    }
                );

                var IsCriminalServicePending = this._CommonService.IsPackageContainCriminalCheckService(JSON.parse(localStorage.getItem('OrderSummaryDetails'))[0].Services)
                if (IsCriminalServicePending == true) {
                    return;
                }
                this._Router.navigate(['/background-login/dashboard']);

            }
        }



    }

    IsServiceCompletedTheInformationOrPendingError(res) {
        this.IsProgressBar = false;

    }

    IsEducationRecordAlreadyExistSuccess(res) {
        let IsCompletedDetails = false;
        let WorkPastId = '';
        this.IsErrorMsg = false;
        if (res !== '') {

            if (this.EducationVerificationModel.EntryInWhichCase === 'SaveForLater') {
                IsCompletedDetails = false;
                WorkPastId = res;
            } else {
                IsCompletedDetails = true;
                WorkPastId = '';
            }
            this.IsServiceCompletedTheInformationOrPending(this.EducationPackageServiceId, IsCompletedDetails, WorkPastId)
        } else {
            this.IsProgressBar = false;
            this.IsErrorMsg = true;
            this.ErrorMsg = 'This Student alredy verified for this order.';
        }
    }

    IsEmployementRecordAlreadyExistSuccess(res) {
        console.log(res);
        let IsCompletedDetails = false;
        let WorkPastId = '';
        this.IsErrorMsg = false;
        if (res !== '') {
            if (this.EmployementVerificationModel.EntryInWhichCase === 'SaveForLater') {
                IsCompletedDetails = false;
                WorkPastId = res;
            } else {
                IsCompletedDetails = true;
                WorkPastId = '';
            }
            this.IsServiceCompletedTheInformationOrPending(this.EmployerPackageServiceId, IsCompletedDetails, WorkPastId);
        } else {
            this.IsProgressBar = false;
            this.IsErrorMsg = true;
            this.ErrorMsg = 'This Employer alredy verified for this order.';

        }
    }

    IsEmployementRecordAlreadyExistError(res) { }

    IsEducationRecordAlreadyExistError(res) { }

    IsProfessionalLicenseAlreadyExistSuccess(res) {
        let IsCompletedDetails = false;
        let WorkPastId = '';
        if (res !== 0) {

            if (this.ProfessionVerificationModel.EntryInWhichCase === 'SaveForLater') {
                IsCompletedDetails = false;
                WorkPastId = res;
            } else {
                IsCompletedDetails = true;
                WorkPastId = '';
            }
            this.IsServiceCompletedTheInformationOrPending(this.ProfessionalPackageServiceId, IsCompletedDetails, WorkPastId);
        } else {
            this.IsProgressBar = false;
            this.IsErrorMsg = true;
            this.ErrorMsg = 'This Licenese already verified for this order.';

        }
    }

    IsProfessionalLicenseAlreadyExistError(res) { }

    SaveForLater() {
        this.IsProgressBar = true;
        this.InsertRecordOfEmplEduandPro('SaveForLater');
    }

    // added to remove snackbar message if we are going to another page.
    ngOnDestroy() {
        this._snackBar.dismiss();

    }

    SetDateOfBirthInputFeild(Id) {
        let $text: any;
        $(Id).keydown(function (e) {
            const key = e.charCode || e.keyCode || 0;
            $text = $(this);
            if (key !== 8 && key !== 7) {
                if ($text.val().length === 2) {
                    $text.val($text.val() + '/');
                }
                if ($text.val().length === 5) {
                    $text.val($text.val() + '/');
                }
            }
            return (key === 8 || key === 9 || key === 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
        });
    }

    SetAdditionInfoPageAccordingToPackageId() {
        let PackageId = atob(localStorage.getItem("PackageId"))
        if (PackageId === "4" || PackageId === "6") {
            this.IsEmployerVerification = true
            this.CountForEmployer = this.CountForEmployer + 1;
        } if (PackageId === "5" || PackageId === "6") {
            this.IsEducationVerification = true
            this.CountForEducation = this.CountForEducation + 1;
        }
        if (PackageId === "6") {
            this.IsThirdEmployyPending = true
            this.IsSecondEmplyPending = true;
        }
        if (this.IsEmployerVerification === true) {
            this.Step = 0


        } else if (this.IsEducationVerification === true) {
            this.Step = 1

        }
    }

    SaveAdditionalInfo(FormReset) {
        this.IsProgressBar = true;
        this.FormReset = FormReset;

        if (this.IsEmployerVerification) {
            this.EmployementVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EmployementVerificationModel.StartDate,
                this.EmployementVerificationModel.EndDate, this.EmployementVerificationModel.CurrentlytWorkHere);
            this.EmployementVerificationModel.ServiceMasterId = 5;
            this.EmployementVerificationModel.UserEmail = localStorage.getItem("Email")
            this.CounterOne++;
            this.EmployementObjectModel.EmploymentObject.push(this.EmployementVerificationModel)
            if (this.IsSecondEmplyPending) {
                this.EmployementSecondVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EmployementSecondVerificationModel.StartDate,
                    this.EmployementSecondVerificationModel.EndDate, this.EmployementSecondVerificationModel.CurrentlytWorkHere);
                this.EmployementSecondVerificationModel.ServiceMasterId = 5;
                this.EmployementSecondVerificationModel.UserEmail = localStorage.getItem("Email")
                this.EmployementObjectModel.EmploymentObject.push(this.EmployementSecondVerificationModel)
            }
            if (this.IsThirdEmployyPending) {
                this.EmployementThirdVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EmployementThirdVerificationModel.StartDate,
                    this.EmployementThirdVerificationModel.EndDate, this.EmployementThirdVerificationModel.CurrentlytWorkHere);
                this.EmployementThirdVerificationModel.ServiceMasterId = 5;
                this.EmployementThirdVerificationModel.UserEmail = localStorage.getItem("Email")
                this.EmployementObjectModel.EmploymentObject.push(this.EmployementThirdVerificationModel)
            }
            this._BackgroundDashboardService.AdditionalEmploymentDetails(this.EmployementObjectModel).
                subscribe(res => this.AdditionalEmploymentDetailsSuccess(res), res => this.AdditionalEmploymentDetailsError(res));
        } if (this.IsEducationVerification) {
            this.EducationVerificationModel.UserEmail = localStorage.getItem("Email")
            this.EducationVerificationModel.FullDateOfJoining = this.ConvertInDateFormat(this.EducationVerificationModel.StartDate,
                this.EducationVerificationModel.EndDate, this.EducationVerificationModel.CurrentlyEnrolled);
            this.CounterOne++;

            this._BackgroundDashboardService.AdditionalEducationalDetails(this.EducationVerificationModel).
                subscribe(res => this.AdditionalEducationalDetailsSuccess(res), res => this.AdditionalEducationalDetailsError(res));

        }
    }


    AdditionalEmploymentDetailsSuccess(res) {
        this.CounterTwo++;
        if (res == true) {
            if (this.CounterOne === this.CounterTwo) {

                const snackBarRef = this._snackBar.open('Your record saved Sucessfully',
                    'OK', {
                        panelClass: ['hideMe'], // added hideMe class in the style.scss for fade in and out
                        verticalPosition: 'bottom'
                    }
                );
                this.OrderTabEnabledAfterAdditionalInfo.emit()
            }
        }
        this.IsProgressBar = false;
    }

    AdditionalEmploymentDetailsError(res) {
        this.IsProgressBar = false;
    }

    AdditionalEducationalDetailsSuccess(res) {
        this.CounterTwo++;
        if (res == true) {
            if (this.CounterOne === this.CounterTwo) {

                const snackBarRef = this._snackBar.open('Your record saved Sucessfully',
                    'OK', {
                        panelClass: ['hideMe'], // added hideMe class in the style.scss for fade in and out
                        verticalPosition: 'bottom'
                    }
                );

                this.OrderTabEnabledAfterAdditionalInfo.emit()
            }
        }


        this.IsProgressBar = false;
    }

    AdditionalEducationalDetailsError(res) {
        this.IsProgressBar = false;
    }

    ShowPendingServiceInAdditionalInfo() {

    }
}
